<template>
  <div class="row">
    <div class="col-md-12">
      <order-difference v-if="order && draftOrder"
                        :originalOrder="order"
                        :updatedOrder="draftOrder"
                        :d365Order="d365Order"
                        :discountPercent="discountPercent"/>
      <hr>
    </div>
    <div v-if="isLoading" class="col-md-12 text-right">
      <app-spinner/>
    </div>
    <template v-else>
      <div class="col-md-2">
        <h4>Refund Summary:</h4>
      </div>
      <div class="col-md-6">
        <refund-transactions :transactions="refund && refund.transactions"/>
      </div>
      <div class="col-md-4 text-right">
        <el-button @click="cancelDraftOrder"
                   type="danger">Cancel Draft Order
        </el-button>
        <el-button @click="updateOrder"
                   type="success">Update Order
        </el-button>
      </div>
    </template>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex';
  import AppSpinner from '../../ui/AppSpinner';
  import OrderDifference from '../Shared/OrderDifference';
  import RefundTransactions from '../Shared/RefundTransactions';
  import {
    ORDER_DRAFT_CANCEL,
    ORDER_UPDATE,
    ORDER_GET_DISCOUNT_PERCENT,
  } from '../../../store/types';

  export default {
    name: 'OrderUpdateConfirmationPage',
    components: {
      AppSpinner,
      OrderDifference,
      RefundTransactions,
    },
    computed: {
      ...mapState({
        isLoading: state => state.order.loading,
        order: state => state.order.order,
        draftOrder: state => state.order.draftOrder,
        refund: state => state.order.payment.refund,
        d365Order: state => state.order.d365Order,
      }),
      ...mapGetters({
        discountPercent: ORDER_GET_DISCOUNT_PERCENT,
      }),
    },
    methods: {
      ...mapActions({
        cancelDraftOrder: ORDER_DRAFT_CANCEL,
        updateOrder: ORDER_UPDATE,
      }),
    },
    created() {
      if(_.isNull(this.order.id)) {
        this.$router.push({path: 'update'});
      }
    },
    mounted() {
      window.scrollTo(0, 0);
    },
  };
</script>
